module.exports = __webpack_public_path__ + "static/media/Lens-Vivid_HK.8e25a578.png";